var _path, _path2, _path3, _path4, _path5, _path6, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHomeDeadInventoryIconCard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 105,
    height: 104,
    viewBox: "0 0 105 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.5 104C81.2188 104 104.5 80.7188 104.5 52C104.5 23.2812 81.2188 0 52.5 0C23.7812 0 0.5 23.2812 0.5 52C0.5 80.7188 23.7812 104 52.5 104Z",
    fill: "#F09552",
    fillOpacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M69.1462 30.8981H42.8135C40.8356 30.8981 39.2322 32.5015 39.2322 34.4794V34.4794C39.2322 36.4572 40.8356 38.0606 42.8135 38.0606H69.1462C71.1241 38.0606 72.7274 36.4572 72.7274 34.4794C72.7274 32.5015 71.1241 30.8981 69.1462 30.8981Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8023 45.2237H86.1572C88.1351 45.2237 89.7385 46.8271 89.7385 48.805C89.7385 50.7829 88.1351 52.3863 86.1572 52.3863H25.8023C23.8245 52.3863 22.2211 50.7829 22.2211 48.805C22.2211 46.8271 23.8245 45.2237 25.8023 45.2237Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8023 59.5488H86.1572C88.1351 59.5488 89.7385 61.1522 89.7385 63.1301C89.7385 65.108 88.1351 66.7114 86.1572 66.7114H25.8023C23.8245 66.7114 22.2211 65.108 22.2211 63.1301C22.2211 61.1522 23.8245 59.5488 25.8023 59.5488Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9293 51.1903C33.8883 51.1917 33.8472 51.1926 33.8062 51.1937C33.7886 51.2393 33.7697 51.2845 33.7478 51.3289L33.9293 51.1903V51.1903Z",
    fill: "#404040"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M93.0625 55.2451C94.9143 32.87 78.2769 13.2303 55.9018 11.3785C33.5267 9.52664 13.887 26.164 12.0351 48.5391C10.1833 70.9142 26.8207 90.5539 49.1958 92.4057C71.5709 94.2576 91.2106 77.6202 93.0625 55.2451Z",
    fill: "#F2994A"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4095_804)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.0149 35.8907L35.3336 60.4C35.0309 60.9242 34.8707 61.5185 34.869 62.1238C34.8673 62.7292 35.0242 63.3244 35.3239 63.8503C35.6237 64.3761 36.0559 64.8144 36.5776 65.1214C37.0993 65.4283 37.6923 65.5934 38.2976 65.6H67.6603C68.2655 65.5934 68.8585 65.4283 69.3802 65.1214C69.9019 64.8144 70.3342 64.3761 70.6339 63.8503C70.9337 63.3244 71.0905 62.7292 71.0888 62.1238C71.0871 61.5185 70.927 60.9242 70.6243 60.4L55.9429 35.8907C55.6339 35.3813 55.1988 34.9601 54.6797 34.6678C54.1605 34.3755 53.5747 34.2219 52.9789 34.2219C52.3831 34.2219 51.7974 34.3755 51.2782 34.6678C50.759 34.9601 50.3239 35.3813 50.0149 35.8907V35.8907Z",
    stroke: "white",
    strokeWidth: 3.9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.9805 44.8V51.7333",
    stroke: "white",
    strokeWidth: 3.9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.9805 58.6666H52.9978",
    stroke: "white",
    strokeWidth: 3.9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4095_804"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 41.6,
    height: 41.6,
    fill: "white",
    transform: "translate(32.1797 29.2)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeDeadInventoryIconCard);
export default __webpack_public_path__ + "static/media/homeDeadInventoryIconCard.d9cc1a517a61992c6d2b4ec5743797f1.svg";
export { ForwardRef as ReactComponent };